export default __webpack_public_path__ + "media/images/icon_logout-3abd28c4fc25290e6e4088c50d3352f4.png";